/**
 * Triggers a browser download of the given blob by creating a temporary anchor element and
 * simulating a click on it. Used both by the Orders List "Download" action (which downloads a
 * previously-saved report) and the in-app header "Download" action for internal valuation orders
 * (which downloads a freshly-generated report).
 */
export const downloadBlobAsFile = (blob: Blob, fileName: string): void => {
  const file = new File([blob], fileName, { type: blob.type });
  const element = document.createElement('a');
  element.setAttribute('href', window.URL.createObjectURL(file));
  element.setAttribute('download', file.name);

  element.style.display = 'none';
  document.body.append(element);

  element.click();

  element.remove();
};
